import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const FeatureSection = () => {
  const {
    t,
    language
  } = useLanguage();
  const isMobile = useIsMobile();
  return <section className="w-full md:py-16 bg-white py-[37px]">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="flex flex-col items-center text-center mb-10">
          <h2 className="md:text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-3 text-2xl">
            {language === 'en' ? t('home.featureTitle') : '翻轉租屋模式，從這裡開始'}
          </h2>
          <p className="md:text-xl text-gray-600 max-w-2xl text-base">
            {language === 'en' ? t('home.featureDesc') : '先查評價再看房，省去不必要的紛爭'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* First Card */}
          <Card className="border shadow-sm hover:shadow-md transition-shadow duration-200">
            <CardHeader>
              <CardTitle className="text-xl font-semibold">
                {language === 'en' ? 'Tenant-Oriented' : '租客導向'}
              </CardTitle>
              <CardDescription>
                {language === 'en' ? 'Now you get to see what landlords don\'t want to reveal' : '以往只能看房東想揭露的資訊，現在你說的算'}
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <AspectRatio ratio={16 / 9} className="overflow-hidden rounded-lg border border-gray-100">
                <img alt={language === 'en' ? "Tenant Experiences" : "租客體驗分享"} src="https://cwuqmrrfvwddicutkrcc.supabase.co/storage/v1/object/public/mainpage//homepage04.png" className="w-full h-full object-cover" />
              </AspectRatio>
              <p className="text-gray-600">
                {language === 'en' ? 'We collect authentic tenant experiences to provide you with honest landlord reviews and property conditions, helping you identify potential issues before signing a lease.' : '收集來自各地租客的經驗，為您提供最真實的房東評價和物件狀況，讓您在租屋前就能了解潛在問題，避免租屋陷阱。'}
              </p>
            </CardContent>
          </Card>

          {/* Second Card */}
          <Card className="border shadow-sm hover:shadow-md transition-shadow duration-200">
            <CardHeader>
              <CardTitle className="text-xl font-semibold">
                {language === 'en' ? 'Community Support Network' : '社群支援網路'}
              </CardTitle>
              <CardDescription>
                {language === 'en' ? 'Building a rental information repository together' : '共同建立租屋資訊庫'}
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <AspectRatio ratio={16 / 9} className="overflow-hidden rounded-lg border border-gray-100">
                <img alt={language === 'en' ? "Rental Community" : "租屋社群"} className="object-cover w-full h-full" src="https://cwuqmrrfvwddicutkrcc.supabase.co/storage/v1/object/public/mainpage//homwpage02.webp" />
              </AspectRatio>
              <p className="text-gray-600">
                {language === 'en' ? 'Join our rental community to share experiences with other tenants. We believe that collective wisdom can create a safer, more transparent rental market.' : '加入我們的租屋社群，與其他租客分享經驗。我們相信透過集體智慧，能夠打造更安全、更公平的租屋市場。'}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default FeatureSection;